// src/components/common/JobStatusBadge.js
import React from 'react';

const JobStatusBadge = ({ status }) => {
    const colors = {
        'Pending':     'bg-red-100 text-red-800',
        'Scheduled':   'bg-blue-100 text-blue-800',
        'In Progress': 'bg-yellow-100 text-yellow-800',
        'Completed':   'bg-green-100 text-green-800',
        'Canceled':    'bg-red-100 text-red-800',
        'Default':     'bg-gray-100 text-gray-800',
    };
    const colorClass = colors[status] || colors['Default'];

    return (
        <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${colorClass}`}>
            {status || 'Unknown'}
        </span>
    );
};

export default JobStatusBadge;